// extracted by mini-css-extract-plugin
module.exports = {"checkBoxesContainer":"ChartDisplayCheckboxes_checkBoxesContainer__2d50v","checkBox":"ChartDisplayCheckboxes_checkBox__20oFw"};